import { render, staticRenderFns } from "./QuizParam.vue?vue&type=template&id=2ea8c612"
import script from "./QuizParam.vue?vue&type=script&lang=js"
export * from "./QuizParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports